export function formatOffset(offsetMs: number): string {
  const totalSeconds = Math.floor(offsetMs / 1000);
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function formatElapsed(elapsedMs: number): string {
  const totalHours = elapsedMs / 3_600_000;
  const totalMinutes = elapsedMs / 60_000;
  const minutes = Math.floor(elapsedMs / 60_000) % 60;
  const seconds = Math.floor(elapsedMs / 1000) % 60;

  if (totalHours >= 1) {
    return `${Math.floor(totalHours)}h ${minutes}m`;
  }

  if (totalMinutes >= 1) {
    return `${minutes}m ${seconds}s`;
  }

  return `${Math.max(0, seconds)}s`;
}

export function formatCriticalElapsed(eventOffsetMs: number, currentOffsetMs: number | null): string {
  if (currentOffsetMs === null) {
    return formatOffset(eventOffsetMs);
  }

  let elapsed = currentOffsetMs - eventOffsetMs;
  if (elapsed < 0) {
    elapsed = 0;
  }

  return `${formatElapsed(elapsed)} ago`;
}
